// src/features/payment/hooks/useCartData.ts
import { useState, useEffect } from "react";
import { errorHandling } from "src/shared/utils/errorHandling";
import { getShoppingCart } from "src/shared/services/servicesv2";
import { Product } from "../../Payment/types/payment";

export const useCartData = (cartId?: string | null) => {
  const [cartProducts, setCartProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cartId) return;

    const fetchCartData = async () => {
      setLoading(true);
      try {
        // const response = await api.get(`/app/pos/v2/shopping_cart/${cartId}`);
        const response = await getShoppingCart(cartId);
        const categoryData: Product[] = response.data.result;
        setCartProducts(categoryData);
      } catch (error) {
        errorHandling(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCartData();
  }, [cartId]);

  return { cartProducts, loading };
};
